import { T } from "../themes";

// ─── SECURE CONTEXT CARD ─────────────────────────────────────────────────────
// Rendered inside the Barcode tab when window.isSecureContext === false.
// The native BarcodeDetector API and getUserMedia both require a secure context.
// HTTP on a LAN IP (192.168.x.x, 10.0.x.x) is NOT a secure context.
// Localhost (127.0.0.1 / ::1) IS a secure context regardless of HTTP/HTTPS.
export default function SecureContextCard({ origin }) {
  return (
    <div style={{
      background:T.surface, border:`3px solid ${T.danger}`,
      boxShadow:`5px 5px 0px ${T.danger}`, padding:"14px 16px", marginBottom:12,
      borderRadius:T.radius,
    }}>
      {/* Header */}
      <div style={{display:"flex", alignItems:"center", gap:10, marginBottom:11,
        paddingBottom:9, borderBottom:`3px solid ${T.danger}`}}>
        <div style={{
          width:32, height:32, background:T.danger, border:`3px solid ${T.surface}`,
          display:"flex", alignItems:"center", justifyContent:"center",
          fontSize:16, flexShrink:0,
        }}>🔒</div>
        <div>
          <p style={{color:T.danger, fontSize:12, fontFamily:T.fontHead,
            fontWeight:900, margin:0, letterSpacing:"1px", textTransform:"uppercase"}}>
            Secure Context Required
          </p>
          <p style={{color:T.textDim, fontSize:9, fontFamily:T.fontMono,
            fontWeight:"bold", margin:0}}>
            Camera hardware is blocked on: <span style={{color:T.gold}}>{origin}</span>
          </p>
        </div>
      </div>

      {/* Explanation */}
      <p style={{color:T.textSub, fontSize:10, fontFamily:T.fontMono,
        fontWeight:"bold", margin:"0 0 10px", lineHeight:1.7}}>
        The <span style={{color:T.success}}>BarcodeDetector</span> API and{" "}
        <span style={{color:T.success}}>getUserMedia</span> require either{" "}
        <span style={{color:T.gold}}>https://</span> or{" "}
        <span style={{color:T.gold}}>http://localhost</span>.{" "}
        HTTP on a LAN IP is not permitted by the browser security model.
      </p>

      {/* Fix options */}
      <p style={{color:T.textDim, fontSize:9, fontFamily:T.fontHead,
        fontWeight:900, margin:"0 0 6px", letterSpacing:"1px", textTransform:"uppercase"}}>
        Fix Options
      </p>
      <div style={{display:"flex", flexDirection:"column", gap:6, marginBottom:12}}>
        {[
          { label:"Use localhost", detail:"Open http://localhost:3000 instead of the LAN IP." },
          { label:"Create React App HTTPS", detail:"In .env: HTTPS=true  then npm start" },
          { label:"Expo HTTPS", detail:"expo start --https" },
          { label:"Self-signed cert", detail:"Caddy or Nginx on 192.168.x.x with a local CA cert." },
        ].map(({ label, detail }) => (
          <div key={label} style={{
            background:T.cardHi, border:`2px solid ${T.danger}`, padding:"7px 10px",
            display:"flex", gap:9, alignItems:"flex-start",
          }}>
            <span style={{color:T.danger, fontSize:10,
              fontFamily:T.fontHead,
              fontWeight:900, flexShrink:0, textTransform:"uppercase",
              letterSpacing:"0.5px", minWidth:130}}>{label}</span>
            <span style={{color:T.textSub, fontSize:10,
              fontFamily:T.fontMono, fontWeight:"bold"}}>{detail}</span>
          </div>
        ))}
      </div>

      {/* Fallback reminder */}
      <div style={{
        background:`${T.success}22`, border:`3px solid ${T.success}`, padding:"8px 12px",
        display:"flex", alignItems:"center", gap:8,
      }}>
        <span style={{fontSize:14}}>⌨️</span>
        <p style={{color:T.success, fontSize:10, fontFamily:T.fontMono,
          fontWeight:"bold", margin:0}}>
          Manual barcode entry below always works regardless of context.
        </p>
      </div>
    </div>
  );
}
